module.exports = __webpack_public_path__ + "img/nursery9.814827a8.jpg";